import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../../theme';

export const StyledIFrame = styled('iframe')`
    width: 100%;
    min-height: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(35), 140)};
`;
